import React, {Component} from 'react';
import { Trans } from 'react-i18next';
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import HeaderGauge from "../header-gauge";
import './index.css';
import Icon from '../../../icon';

class Plan extends Component {

	constructor(props){
		super(props);
		this.state = {
			isHover: false
		}
	}

	onMouseEnter = () => {
		this.setState({isHover:true})

	};

	onMouseLeave = () => {
		this.setState({isHover:false})
	};

    render() {

        const domainStatusDisplay = () => {
            if(this.props.profile !== null){
                if(this.props.profile.domain !== null){
                    switch (this.props.profile.domain.status) {
                        case 'FREE':
                            return (
                                <span>{this.props.t("textInvited")}</span>
                            );
	                    case 'FREEMIUM':
		                    return (
			                    <span>FREEMIUM</span>
		                    );
                        case 'EVAL':
                            return (
                                <span>{this.props.t("textEvaluation")}</span>
                            );
	                    case 'EXPIRED':
		                    if (this.props.profile.domain.plan === "INVITED") {
			                    return (
				                    <span>{this.props.t("textInvited")}</span>
			                    );
		                    } else {
			                    return (
				                    <span className="text-danger">{this.props.t("expiredText")}</span>
			                    );
		                    }
                        case 'EXPIRED_EVAL':
                            return (
	                            <span className="text-danger">{this.props.t("expiredevaluationText")}</span>
                            );
	                    case 'EXPIRED_PAID':
		                    if (this.props.profile.domain.plan === "INVITED") {
			                    return (
				                    <span>{this.props.t("textInvited")}</span>
			                    );
		                    } else {
			                    return (
				                    <span className="text-danger">{this.props.t("statusExpiredPaid")}</span>
			                    );
		                    }
                        case 'INVITED_EVAL':
                            return (
                                <span>{this.props.t("textEvaluation")} ({this.props.t("textInvited")})</span>
                            );
                        case 'INVITED_EXPIRED':
		                    return (
                                <span className="text-danger">{this.props.t("expiredText")} ({this.props.t("textInvited")})</span>
                            );
                        case 'INVITED_EXPIRED_EVAL':
                            return (
	                            <span className="text-danger">{this.props.t("expiredevaluationText")} ({this.props.t("textInvited")})</span>
                            );
	                    case 'INVITED_EXPIRED_PAID':
		                    return (
                                <span className="text-danger">{this.props.t("statusExpiredPaid")} ({this.props.t("textInvited")})</span>
                            );
                        case 'INVITED_PAID':
                            if (this.props.profile.domain.plan === "BASIC" || this.props.profile.inviterPlan === "BASIC") {
                                return (
                                   <span>{this.props.t("textBasic")} ({this.props.t("textInvited")}</span>
                                );
                            } else if (this.props.profile.domain.plan === "LITE" || this.props.profile.inviterPlan === "LITE") {
                                return (
                                    <span>{this.props.t("textLite")} ({this.props.t("textInvited")})</span>
                                );
                            } else if (this.props.profile.domain.plan === "PRO" || this.props.profile.inviterPlan === "PRO"){
                                return (
	                                <span>{this.props.t("statusProfessional")} ({this.props.t("textInvited")})</span>
                                );
                            } else if (this.props.profile.domain.plan === "TEAM" || this.props.profile.inviterPlan === "TEAM"){
                                return (
                                    <span>{this.props.t("textTeam")} ({this.props.t("textInvited")})</span>
                                );
                            } else if (this.props.profile.domain.plan === "BUSINESS" || this.props.profile.inviterPlan === "BUSINESS"){
                                return (
                                    <span>{this.props.t("textBusiness")} ({this.props.t("textInvited")})</span>
                                );
                            } else if (this.props.profile.domain.plan === "ENTERPRISE" || this.props.profile.inviterPlan === "ENTERPRISE"){
                                return (
                                    <span>{this.props.t("textEnterprise")} ({this.props.t("textInvited")})</span>
                                );
                            } else if (this.props.profile.domain.plan === "CORPORATE" || this.props.profile.inviterPlan === "CORPORATE"){
                                return (
                                    <span>{this.props.t("textCorporate")} ({this.props.t("textInvited")})</span>
                                );
                            } else if (this.props.profile.domain.plan === "MOBILE" || this.props.profile.inviterPlan === "MOBILE"){
	                            return (
		                            <span>{this.props.t("textMobile")} ({this.props.t("textInvited")})</span>
	                            );
                            } else {
                                return (
	                                <span>{this.props.t("statusUnknownPlan")} ({this.props.t("textInvited")})</span>
                                );
                            }
                        case 'INVITED_UNINSTALLED_EVAL':
                            return (
	                            <span className="text-danger">{this.props.t("textEvaluation")} ({this.props.t("textInvited")})</span>
                            );
                        case 'INVITED_UNINSTALLED_EXPIRED':
                            return (
	                            <span className="text-danger">{this.props.t("expiredText")} ({this.props.t("textInvited")})</span>
                            );
	                    case 'INVITED_UNINSTALLED_PAID':
		                    if (this.props.profile.domain.plan === "BASIC" || this.props.profile.inviterPlan === "BASIC") {
			                    return (
				                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                                        <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textBasic")}
                                        </span>
                                        {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "LITE" || this.props.profile.inviterPlan === "LITE") {
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textLite")} ({this.props.t("textInvited")})
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "PRO" || this.props.profile.inviterPlan === "PRO"){
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("statusProfessional")} ({this.props.t("textInvited")})
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "TEAM" || this.props.profile.inviterPlan === "TEAM"){
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textTeam")} ({this.props.t("textInvited")})
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "BUSINESS" || this.props.profile.inviterPlan === "BUSINESS"){
			                    return (
			                        <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                                        <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textBusiness")} ({this.props.t("textInvited")})
                                        </span>
                                        {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
			                        </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "ENTERPRISE" || this.props.profile.inviterPlan === "ENTERPRISE"){
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textEnterprise")} ({this.props.t("textInvited")})
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "CORPORATE" || this.props.profile.inviterPlan === "CORPORATE"){
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textCorporate")} ({this.props.t("textInvited")})
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "MOBILE" || this.props.profile.inviterPlan === "MOBILE"){
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textMobile")} ({this.props.t("textInvited")})
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else {
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("statusUnknownPlan")} ({this.props.t("textInvited")})
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    }
                        case 'UNINSTALLED_EVAL':
                            return (
	                            <span className="text-danger">{this.props.t("statusUninstalledEval")}</span>
                            );
	                    case 'UNINSTALLED_EXPIRED':
		                    return (
			                    <span className="text-danger">{this.props.t("statusUninstalledExpired")}</span>
		                    );
	                    case 'UNINSTALLED_PAID':
		                    if (this.props.profile.domain.plan === "BASIC") {
			                    return (
				                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                                        <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textBasic")}
                                        </span>
                                        {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "LITE") {
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textLite")}
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "PRO"){
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("statusProfessional")}
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "TEAM"){
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textTeam")}
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "BUSINESS"){
			                    return (
			                        <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                                        <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textBusiness")}
                                        </span>
                                        {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
			                        </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "ENTERPRISE"){
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textEnterprise")}
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "CORPORATE"){
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textCorporate")}
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else if (this.props.profile.domain.plan === "MOBILE"){
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("textMobile")}
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    } else {
			                    return (
                                    <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
					                    <span className="text-danger">
                                            <Icon name="warning"/> {this.props.t("statusUnknownPlan")}
                                        </span>
					                    {this.state.isHover && <span className="plan__tooltip">{this.props.t("tooltipUninstalledPaid")}</span>}
                                    </div>
			                    );
		                    }
                        case 'PAID':
                            if (this.props.profile.domain.plan === "BASIC") {
                                return (
                                   this.props.t("textBasic")
                                );
                            } else if (this.props.profile.domain.plan === "LITE") {
                                return (
                                    this.props.t("textLite")
                                );
                            } else if (this.props.profile.domain.plan === "PRO"){
                                return (
	                                this.props.t("statusProfessional")
                                );
                            } else if (this.props.profile.domain.plan === "TEAM"){
                                return (
                                    this.props.t("textTeam")
                                );
                            } else if (this.props.profile.domain.plan === "BUSINESS"){
                                return (
                                    this.props.t("textBusiness")
                                );
                            } else if (this.props.profile.domain.plan === "ENTERPRISE"){
                                return (
                                    this.props.t("textEnterprise")
                                );
                            } else if (this.props.profile.domain.plan === "CORPORATE"){
                                return (
                                    this.props.t("textCorporate")
                                );
                            } else if (this.props.profile.domain.plan === "MOBILE"){
	                            return (
		                            this.props.t("textMobile")
	                            );
                            } else {
                                return (
	                                this.props.t("statusUnknownPlan")
                                );
                            }
                        default:
                            return '';
                    }
                } else {
                    return null;
                }
            }
        };

        return (
            <div className="d-flex flex-column justify-content-center plan text-right">
                <div className="font-weight-bold text-uppercase mb-0 position-relative">{domainStatusDisplay()}</div>
                {
                    this.props.profile !== null
                    && this.props.profile.license
	                && this.props.profile.domain.status === "EVAL"
                    && <p className="text-danger mb-0">
	                    <Trans i18nKey="textExpiry" values={{no_of_days: this.props.profile.license.daysLeft}} />
                    </p>
                }
                {
                    this.props.profile !== null
                    ?
                        this.props.profile.domain && this.props.profile.license
                        ?
                            this.props.profile.domain.status !== "EVAL"
                            && this.props.profile.domain.status !== "EXPIRED"
                            && this.props.profile.domain.status !== "EXPIRED_EVAL"
                            && this.props.profile.domain.status !== "EXPIRED_PAID"
                            && this.props.profile.domain.status !== "FREE"
	                        && this.props.profile.domain.status !== "FREEMIUM"
                            && <HeaderGauge
                                color={'#cfc'}
                                value={this.props.profile.license.licensesUsed}
                                label={this.props.profile.license.licensesUsed ? 'users' : 'user'}
                                max={this.props.profile.license.licensesNumber}
                                details={`${this.props.profile.license.licensesUsed} user${this.props.profile.license.licensesUsed > 1 ? 's' : ''} out of ${this.props.profile.license.licensesNumber} license${this.props.profile.license.licensesNumber > 1 ? 's' : ''}`}
                                overQuota={this.props.profile.license.licensesUsed > this.props.profile.license.licensesNumber}
                            />
                        :
                            null
                    :
                        null
                }
                {/*
                    this.props.profile !== null
                    ?
                        this.props.profile.domain
                        ?
                            this.props.profile.domain.plan !== "INVITED"
                            ?
                                this.props.profile.domain.status === 'PAID' && (this.props.profile.domain.plan === 'LITE' || this.props.profile.domain.plan === 'TEAM' || this.props.profile.domain.plan === 'BUSINESS')
                                ?
                                    <p className="mb-0"><a href={`${API_ROOT}/sm/subscriptions`} target="_blank"><Icon name="external-link"/> Manage subscription</a></p>
                                :
                                    <p className="mb-0"><a href={`${API_ROOT}/sm/profile`} target="_blank"><Icon name="external-link"/> Manage profile</a></p>
                            :
                                null
                        :
                            null
                    : null
                */}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        profile : state.profileReducer.getProfile
    };
};

export default connect(mapStateToProps)(withTranslation()(Plan));
